import { Box } from "@mui/material";

import { Button } from "./Button";

interface FloatingNavigationButtonProps {
  label: string;
  href: string;
  onClick?: () => void;
}

/**
 * A floating pill-shaped button fixed at the bottom center of the screen.
 * Used to toggle navigation between related pages (e.g., Shift History ↔ Earnings).
 */
export function FloatingNavigationButton(props: FloatingNavigationButtonProps) {
  const { label, href, onClick } = props;

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: (theme) => theme.spacing(8),
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1,
      }}
    >
      <Button variant="contained" size="medium" href={href} onClick={onClick}>
        {label}
      </Button>
    </Box>
  );
}
